<template>
  <form
    class="editmode-container"
    @submit.prevent="saveEditClick"
  >
    <slot name="input" />
    <slot name="select" />
    <div class="editmode-button-container">
      <button
        class="button--40 button--text-icon"
        type="submit"
      >
        <svgicon name="Controls/Check" />Spara
      </button>
      <button
        class="button--secondary button--40 button--text-icon"
        @click="cancelEditClick()"
      >
        <svgicon name="Controls/Close" />Avbryt
      </button>
    </div>
  </form>
</template>

<script>
import "#/Controls/Check"
import "#/Controls/Close"

export default {
  name: "EditMode",
  methods: {
    saveEditClick () {
      this.$emit("saveEditMode")
    },
    cancelEditClick () {
      this.$emit("cancelEditMode")
    }
  }
}
</script>

<style lang='scss'>
.editmode-container {
  display: flex;
  flex-direction: column;
  width: 100%;

  .input-text,
  .ica-select {
    @include media-breakpoint-up(lg) {
      flex-grow: 2;
      margin-right: 1rem;
    }
  }

  .editmode-button-container {
    display: flex;
    flex-direction: column;
    margin-top: 1rem;

    button:not(:last-child) {
      margin-bottom: 0.5rem;

      @include media-breakpoint-up(lg) {
        margin-bottom: 0;
      }
    }

    @include media-breakpoint-up(md) {
      flex-direction: row;
      align-items: start;

      button:not(:last-child) {
        margin-right: 0.5rem;
      }
    }

    @include media-breakpoint-up(lg) {
      margin-top: 0.25rem;
    }
  }

  @include media-breakpoint-up(lg) {
    flex-direction: row;
    align-items: flex-start;
  }
}
</style>
